import React from 'react';

interface Props {
  children?: React.ReactNode;
}

interface State {
  error?: Error;
  reactErrorInfo?: React.ErrorInfo;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: undefined, reactErrorInfo: undefined };

  componentDidCatch(error: Error, reactErrorInfo: React.ErrorInfo) {
    // You can also log error messages to an error reporting service here
    // logErrorToMyService(error, reactErrorInfo);
    this.setState({
      error: error,
      reactErrorInfo: reactErrorInfo,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <>
          <h2>Something went wrong.</h2>
          <p>{this.state.error.message}</p>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
